import { render, staticRenderFns } from "./RemoveTeamMemberModal.vue?vue&type=template&id=fa448836&scoped=true"
import script from "./RemoveTeamMemberModal.vue?vue&type=script&lang=js"
export * from "./RemoveTeamMemberModal.vue?vue&type=script&lang=js"
import style0 from "./RemoveTeamMemberModal.vue?vue&type=style&index=0&id=fa448836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa448836",
  null
  
)

export default component.exports